// HM-310.r cluster 15 visual rework: TopBar matched a
// docs/design-references/dashboard-v2-reference.html.
// Search box centrale max 480px + bell con badge arancio + clock display.
// NIENTE avatar dropdown (logout ora vive in Sidebar.UserCard).

import { useEffect, useState } from 'react';
import { Bell, Search } from './icons';
import { cn } from './lib/cn';

export interface TopBarProps {
  notificationCount?: number;
  onSearchSubmit?: (query: string) => void;
  /** Quando undefined la TopBar mostra l'orologio in tempo reale aggiornato ogni minuto. */
  clockOverride?: string;
}

export function TopBar(props: TopBarProps) {
  const clock = useNowClock(props.clockOverride);

  return (
    <header
      // HM-316.r cluster 15.4: sticky top:0 z:30 per restare visibile durante
      // lo scroll del content. z-30 < z-40 sidebar < z-50 modali.
      className="sticky top-0 z-30 bg-bg-topbar border-b border-border-base flex items-center gap-4 px-6 py-3.5 flex-shrink-0"
    >
      <form
        className="flex-1 max-w-[480px] relative"
        onSubmit={(e) => {
          e.preventDefault();
          const fd = new FormData(e.currentTarget);
          props.onSearchSubmit?.(String(fd.get('q') ?? ''));
        }}
      >
        <Search
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none"
        />
        <input
          name="q"
          type="search"
          placeholder="Cerca camera, ospite, prenotazione..."
          className={cn(
            'w-full px-3.5 pl-9 py-2.5 rounded-lg bg-bg-base border border-border-base',
            'text-[13px] text-text-primary placeholder:text-text-muted',
            'focus:outline-none focus:border-accent-primary focus:bg-bg-card',
            'transition-colors',
          )}
        />
      </form>

      <div className="flex items-center gap-4 ml-auto">
        <button
          type="button"
          aria-label="Notifiche"
          className="relative p-2 rounded-lg text-text-secondary hover:bg-bg-base transition-colors"
        >
          <Bell size={20} strokeWidth={1.75} />
          {(props.notificationCount ?? 0) > 0 && (
            <span className="absolute top-0.5 right-0.5 min-w-[16px] h-4 px-1 rounded-lg bg-accent-primary text-text-on-accent text-[10px] font-semibold flex items-center justify-center leading-none">
              {props.notificationCount}
            </span>
          )}
        </button>
        <div className="text-xs text-text-secondary px-3.5 py-2 bg-bg-base rounded-lg font-medium tabular-nums">
          {clock}
        </div>
      </div>
    </header>
  );
}

/** Formato "10 mag · 14:23" come da mockup. Refresh ogni 30s. */
function useNowClock(override?: string): string {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (override) return;
    const t = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(t);
  }, [override]);

  if (override) return override;
  return formatClock(now);
}

const MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

function formatClock(d: Date): string {
  const day = d.getDate();
  const month = MONTHS[d.getMonth()] ?? '';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${day} ${month} · ${hh}:${mm}`;
}
